// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","wrapContent":"Hero_wrapContent__BYVYc","btn":"Hero_btn__ipVZT","block":"Hero_block__GSc64"};